let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8L4O3")).then(() => parcelRequire('i1Kmk'));